/**
 * Category name constants — intentionally kept in a standalone file
 * with NO imports to avoid circular dependency issues.
 *
 * `evaluation.ts` imports data files which need these constants,
 * so these must live outside of that module graph.
 */
export const CATEGORY_INNOVATION = 'Innovation Excellence Award';
export const CATEGORY_SUSTAINABLE = 'Sustainable Solution Award';
export const CATEGORY_DIGITAL_TRANSFORMATION =
  'Digital Transformation Champion Award';
export const CATEGORY_AI = 'AI Breakthrough Award';
export const CATEGORY_YOUNG_LEADER = 'Young Digital Leader Award';
export const CATEGORY_WOMEN_IN_TECH = 'Women in Tech Award';

export const CATEGORY_NEW_BUSINESS_VENTURE = 'New Business Venture';
export const CATEGORY_WOMEN_IN_TECH_2026 = 'Women in Tech';
export const CATEGORY_DIGITAL_CATALYST = 'Digital Catalyst';

export const AWARD_CATEGORIES: string[] = [
  CATEGORY_INNOVATION,
  CATEGORY_SUSTAINABLE,
  CATEGORY_DIGITAL_TRANSFORMATION,
  CATEGORY_AI,
  CATEGORY_YOUNG_LEADER,
  CATEGORY_WOMEN_IN_TECH,
  CATEGORY_NEW_BUSINESS_VENTURE,
  CATEGORY_WOMEN_IN_TECH_2026,
  CATEGORY_DIGITAL_CATALYST,
];

export const CATEGORIES_BY_YEAR: Record<number, string[]> = {
  2025: [
    CATEGORY_INNOVATION,
    CATEGORY_SUSTAINABLE,
    CATEGORY_DIGITAL_TRANSFORMATION,
    CATEGORY_AI,
    CATEGORY_YOUNG_LEADER,
    CATEGORY_WOMEN_IN_TECH,
  ],
  2026: [
    CATEGORY_DIGITAL_TRANSFORMATION,
    CATEGORY_SUSTAINABLE,
    CATEGORY_AI,
    CATEGORY_NEW_BUSINESS_VENTURE,
    CATEGORY_WOMEN_IN_TECH_2026,
    CATEGORY_DIGITAL_CATALYST,
  ],
};
